import type { Scene } from '../types';
import apiRequest from './apiRequest';

export type SceneListResponse = {
  scenes: Scene[];
  nextToken?: string;
};

export default async function getScenes(
  apiKey: string,
  params?: { limit?: number; nextToken?: string; sortAscending?: boolean },
  signal?: AbortSignal,
) {
  const urlParams = new URLSearchParams();
  if (params?.limit != null) {
    urlParams.set('limit', params.limit.toString());
  }
  if (params?.nextToken) {
    urlParams.set('nextToken', params.nextToken);
  }
  if (params?.sortAscending != null) {
    urlParams.set('sortAscending', params.sortAscending.toString());
  }

  const query = urlParams.toString() ? `?${urlParams.toString()}` : '';

  return apiRequest<SceneListResponse>(
    'external-mogen',
    `/scenes${query}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
    signal,
  );
}
